import crypto from 'node:crypto';
const md5 = (str) => crypto.createHash('md5').update(str).digest('hex');
const stringifyWmlFile = ({ content }) => content;
export const hashWml = ({ structure, style, data, version }) => {
    const wmlString = version + stringifyWmlFile(structure) + stringifyWmlFile(data) + stringifyWmlFile(style);
    return md5(wmlString);
};
